import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AddNilDip from "./AddNilDip";
import ConfirmBox from "../../../UiComponents/ConfirmBox/ConfirmBox";
import {
    AddIcon,
    SearchIcon,
    DeleteIcon,
} from "../../../Resources/Icons/icons";
import {
    GetNilDip,
    DeleteNilDip,
    FilterNilDip,
} from "../../../Service/_index";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../../UiComponents/Transition/Transition";
import { Divider } from "@mui/material";
import TabFilter from "../../../Components/Tabs/Tabs";
import MasterCommonTable from "../../../UiComponents/CommonTable/MasterCommonTable";
import DeleteImage from "../../../../src/Resources/Images/delete_common.png";

const FilterOption = [
    {
        label: "All Data",
        isActive: "all",
        value: 1,
    },
    {
        label: "Active Data",
        isActive: "true",
        value: 2,
    },
    {
        label: "Inactive Data",
        isActive: "false",
        value: 3,
    },
];

const getClassName = (data) => {
    return data.status === "Active"
        ? "Active-chip"
        : data.status === "Inactive"
            ? " inActive-chip"
            : "";
};

const headCells = [
    {
        id: "value",
        placeMent: true,
        disablePadding: false,
        label: "Depreciation Value",
    },
    {
        id: "Description",
        placeMent: true,
        disablePadding: false,
        label: "Description",
    },
    {
        id: "createdAt",
        placeMent: true,
        disablePadding: false,
        label: "Created Date",
    },
    {
        id: "status",
        placeMent: true,
        disablePadding: false,
        label: "Status",
        class: getClassName,
    },
];

const NilDip = () => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [selectedData, setSelectedData] = React.useState({});
    const [openDrawer, setOpenDrawer] = React.useState(false);
    const [openDeleteConfirm, setOpenDeleteConfirm] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [searchText, setSearchText] = useState("");
    const [tableConfig] = useState({
        isAction: true,
        isEdit: true,
        isDelete: true,
        isSearch: true,
        historyEntity: "zeroDepreciation",
    });
    const [selectedTab, setSelectedTab] = useState(1);
    const [loading, setLoading] = useState(false);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
        const selectedOption = FilterOption.find(
            (option) => option.value === newValue
        );
        FilterFunction(selectedOption);
    };

    const FilteredData = data.filter((el) => {
        return `${el?.value},${el?.Description}` || '--'
            .toLowerCase()
            .includes(searchText.toLowerCase());
    });

    const GetData = () => {
        setLoading(true);
        GetNilDip().then((res) => {
            if (res && res.data) {
                const updatedData = res.data.map((item) => ({
                    ...item,
                    createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
                    status: item.isActive ? "Active" : "Inactive",
                }));
                setData(updatedData);
            }
            setLoading(false);
        });
    };

    React.useEffect(() => {
        GetData();
    }, []);

    const handleEdit = (row) => {
        setSelectedData(row);
        setOpenDrawer(true);
    };

    const handleAdd = () => {
        setSelectedData({});
        setOpenDrawer(true);
    };

    const handleDelete = (row) => {
        setSelectedData(row);
        setOpenDeleteConfirm(true);
    };

    const confirmDelete = () => {
        DeleteNilDip(selectedData._id).then((res) => {
            GetData();
            setOpenDeleteConfirm(false);
        });
    };

    const FilterFunction = (e) => {
        let isActive = e?.isActive;
        if (isActive === "all") {
            GetData();
        } else {
            setLoading(true);
            FilterNilDip({ isActive: isActive === "true" }).then((res) => {
                if (res && res.data) {
                    const updatedData = res.data.map((item) => ({
                        ...item,
                        createdAt: moment(item.createdAt).format("DD/MM/YYYY hh:mm A"),
                        status: item.isActive ? "Active" : "Inactive",
                    }));
                    setData(updatedData);
                }
                setLoading(false);
            });
        }
        setPage(0);
    };

    return (
        <>
            <Grid container className="Master_Card_Container">
                <Grid
                    container
                    alignItems={"center"}
                    className="Master_Card_Sub_Container"
                >
                    <Grid item xs={12} sm={6} md={6}>
                        <Typography className="Master_Card_Tittle">Nil Dip (Zero Depreciation)</Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        className="d-flex justify-content-end"
                    >
                        <Button
                            className="Master_Card_create_Button w-100"
                            startIcon={<AddIcon />}
                            onClick={handleAdd}
                        >
                            Create
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Divider sx={{ backgroundColor: "#EAECF0", borderWidth: 1 }} />
                </Grid>
                <Grid
                    container
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    className="Master_Card_Sub_Container"
                >
                    <TabFilter
                        options={FilterOption}
                        selectedTab={selectedTab}
                        onTabChange={handleTabChange}
                    />
                    <Grid item xs={12} sm={4} md={3.1} mt={{ xs: 2, sm: 0, md: 0 }}>
                        <Input
                            className="w-100 Master_Card_Input"
                            onChange={(e) => {
                                setSearchText(e.target.value);
                                setPage(0);
                            }}
                            disableUnderline={true}
                            placeholder="Search in Nil Dip..."
                            startAdornment={
                                <InputAdornment position="start">
                                    <IconButton>
                                        <SearchIcon sx={{ fontSize: "20px" }} />
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </Grid>
                </Grid>
                <MasterCommonTable
                    tableConfig={tableConfig}
                    data={FilteredData}
                    columns={headCells}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    tableTotalCount={FilteredData.length}
                    loading={loading}
                />
            </Grid>

            <Dialog
                open={openDrawer}
                TransitionComponent={Transition}
                keepMounted
                PaperProps={{
                    sx: {
                        maxWidth: { xs: "80%", sm: "70%", md: "50%", lg: "40%" },
                    },
                }}
            >
                {openDrawer && (
                    <AddNilDip
                        title={selectedData._id ? "Edit" : "Create"}
                        selectedData={selectedData}
                        formType={selectedData._id ? "edit" : "add"}
                        setOpenDrawer={setOpenDrawer}
                        GetData={GetData}
                    />
                )}
            </Dialog>

            <ConfirmBox
                open={openDeleteConfirm}
                title="Delete"
                content="Are you sure you want to delete this Nil Dip record?"
                subContent="This action cannot be undone."
                img={DeleteImage}
                confirmButton="Delete"
                setOpenConfirmBox={setOpenDeleteConfirm}
                Function={confirmDelete}
                icon={<DeleteIcon />}
                color="error"
            />
        </>
    );
};

export default NilDip;
